import { useNavigate, Link } from "react-router-dom";
import styles from "./sideBar.module.css";
import { User, Calendar, FileText, Truck, Power, ExternalLink, X } from "react-feather";
import { authData } from "../../admin/components/GetAuth";
import dayjs from "dayjs";
import { Alert, Button, Dialog, DialogContent, DialogTitle, Snackbar } from "@mui/material";
import { useState } from "react";
import AddmembershipForm from "./AddmembershipForm";
import Loader from "../../admin/components/Loader";

function SideBar() {
  const auth = authData();
  const navigate = useNavigate();
  const [addMembershipModalShow, setAddMembershipModalShow] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [loading, setLoading] = useState(false);

  const logout = () => {
    localStorage.removeItem("authData");
    navigate("/");
  };

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.CustoSideNav}`}>
      <ul>
        <li className={`${styles.ListHead}`}>
          <div className={`${styles.CusAvatar}`}>
            <span>{auth?.customer?.name_initials}</span>
          </div>
          <div style={{ paddingLeft: '10px' }}>
            <p>{auth?.customer?.name}</p>
            <span>Referral Points: <strong>£{auth?.customer?.referral_point}</strong></span>
          </div>
        </li>
        <li className={`${styles.ListHead2}`}>
          {auth?.customer?.membership_expired_date && <div>Membership expired on <strong>{dayjs(auth?.customer?.membership_expired_date).format('MMM D YYYY')}</strong></div>}
          {(!auth?.customer?.membership_expired_date && auth?.customer?.is_membership === 1) && <Button className={`${styles.SideEditBU}`} onClick={(e) => setAddMembershipModalShow(true)}>Subscribe</Button>}
        </li>
        <li>
          <Link to={"/customer/my-bookings"}>
            <FileText /> My booking
          </Link>
        </li>
        <li>
          <Link to={"/customer/add-booking"}>
            <Calendar /> Add a booking
          </Link>
        </li>
        <li>
          <Link to={"/customer/track-booking"}>
            <Truck /> Track a booking
          </Link>
        </li>
        <li>
          <Link to={"/customer/referral-histories"}>
            <ExternalLink /> Referral History
          </Link>
        </li>
        <li>
          <Link to={"/customer/profile"}>
            <User /> My profile
          </Link>
        </li>
        <li>
          <button onClick={logout.bind(this)}>
            <Power /> Logout
          </button>
        </li>
      </ul>
    </div>

    <Dialog
      open={addMembershipModalShow}
      onClose={(e) => setAddMembershipModalShow(false)}
      fullWidth
      maxWidth="xs"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Subscribe Membership
        <button onClick={(e) => setAddMembershipModalShow(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <AddmembershipForm id={auth?.customer?.id} setAddMembershipModalShow={setAddMembershipModalShow.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} />
      </DialogContent>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
}

export default SideBar;